import ApplicationSerializer from 'cio/serializers/application';

export default class IntegrationsCdpOutSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey() {
    return super.modelNameFromPayloadKey('integrations/cdp-out');
  }

  payloadKeyFromModelName() {
    return 'cdp_out';
  }
}
